<template>
  <footer class="footer">
    <div class="row">
      <div class="hide-for-small medium-1 columns">
        <img class="footer__signet" src="/static/gainvest-signet.svg" alt="Sygnet Gainvest">
      </div>
      <div class="small-12 medium-order-2 medium-offset-1 medium-2 columns">
        <div class="margin-bt-2">
          TELEFON:<br>
          <a :href="`tel:${contact[2]}`">{{ contact[2] }}</a>
        </div>
        <div class="margin-bt-2">
          MAIL:<br>
          <a :href="`mail:${contact[3]}`">{{ contact[3] }}</a>
        </div>
      </div>
      <div class="small-12 medium-order-0 medium-offset-1 medium-3 columns">
        <ul class="links-list">
          <li><router-link title="Link do zysku" :to="{ name: 'Gain', params: {id: 0} }">Inwestor biznesowy</router-link></li>
          <li><router-link title="Link do zysku" :to="{ name: 'Gain', params: {id: 1} }">Firma budowlana</router-link></li>
          <li><router-link title="Link do zysku" :to="{ name: 'Gain', params: {id: 2} }">Deweloperzy</router-link></li>
          <li><router-link title="Link do zysku" :to="{ name: 'Gain', params: {id: 3} }">Biuro nieruchomości</router-link></li>
        </ul>
      </div>
      <div class="small-10 medium-order-1 medium-3 columns">
        <ul class="links-list">
          <li><router-link title="Link do zysku" :to="{ name: 'Gain', params: {id: 4} }">Biuro projektowe</router-link></li>
          <li><router-link title="Link do zysku" :to="{ name: 'Gain', params: {id: 5} }">Biura pozyskania finansowego</router-link></li>
          <li><router-link title="Link do zysku" :to="{ name: 'Gain', params: {id: 6} }">Banki</router-link></li>
          <li><router-link title="Link do zysku" :to="{ name: 'Gain', params: {id: 6} }">Klient indywidualny</router-link></li>
        </ul>
      </div>
      <div class="small-2 medium-order-3 medium-1 columns footer__sm-container">
        <a href="#"><img class="footer__sm" src="/static/icons/facebook.svg" alt=""></a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data () {
    return {
      items: [],
      contact: []
    }
  },
  beforeCreate: function () {
    this.$http.get(`wp/v2/gain?per_page=100`).then(response => {
      for (let post in response.data) {
        this.items.push(response.data[post])
      }
    }, error => { console.log(error) })

    this.$http.get(`contact-data/v1/contact`).then(response => {
      for (let post in response.data) {
        this.contact.push(response.data[post])
      }
    }, error => { console.log(error) })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue